import { render, staticRenderFns } from "./PublicReviewLayout.vue?vue&type=template&id=713389cb&scoped=true&"
import script from "./PublicReviewLayout.vue?vue&type=script&lang=ts&"
export * from "./PublicReviewLayout.vue?vue&type=script&lang=ts&"
import style0 from "./PublicReviewLayout.vue?vue&type=style&index=0&id=713389cb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "713389cb",
  null
  
)

export default component.exports